module.exports = __webpack_public_path__ + "img/ricelog_pinicon_101.a17f90de.png";